import type { IconData } from '@stacksjs/iconify-core'

export const userMd: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17.998 8.064L6.003 8.11l-.277-3.325A3 3 0 0 1 8.17 1.482l.789-.143a17 17 0 0 1 6.086 0l.786.143a3 3 0 0 1 2.443 3.302Z\"/><path fill=\"currentColor\" d=\"M6.009 8.109a5.994 5.994 0 0 0 11.984-.045Z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"m17.198 13.385l-4.49 4.49a1 1 0 0 1-1.415 0l-4.491-4.49a9.95 9.95 0 0 0-4.736 7.44a1 1 0 0 0 .994 1.108h17.88a1 1 0 0 0 .994-1.108a9.95 9.95 0 0 0-4.736-7.44\"/><path fill=\"currentColor\" d=\"M15.69 12.654a6.01 6.01 0 0 1-7.381 0a10 10 0 0 0-1.507.73l4.491 4.492a1 1 0 0 0 1.414 0l4.491-4.491a10 10 0 0 0-1.507-.731Z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default userMd
